(function () {
  'use strict';

  if (window.WRCartRedesignLoaded) return;
  window.WRCartRedesignLoaded = true;

  var STARTER_SLOTS = ['starter_base', 'starter_bar', 'starter_symbol_1', 'starter_symbol_2'];
  var refreshTimer;
  var lastSignature = '';

  function property(item, key) {
    return item.properties && item.properties[key];
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function config() {
    var node = document.querySelector('[data-wr-cart-config]');
    if (!node) return {};
    try { return JSON.parse(node.textContent); }
    catch (error) { return {}; }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }

  function groupedCart(cart) {
    var groups = {};
    var order = [];
    var standalone = [];
    (cart.items || []).forEach(function (item) {
      var buildId = property(item, '_bracelet_build_id');
      if (!buildId) {
        standalone.push(item);
        return;
      }
      if (!groups[buildId]) {
        groups[buildId] = [];
        order.push(buildId);
      }
      groups[buildId].push(item);
    });
    return { groups: groups, order: order, standalone: standalone };
  }

  function starterLines(lines) {
    return lines.filter(function (line) {
      return STARTER_SLOTS.indexOf(property(line, '_bracelet_slot')) > -1;
    });
  }

  function buildInfo(lines) {
    var starter = starterLines(lines);
    var first = starter[0] || lines[0] || {};
    var cfg = config();
    var presetKey = property(first, '_curated_set_key');
    var displayName = property(first, '_bracelet_display_name') || 'Your Custom Bracelet';
    var bar = property(first, '_bracelet_bar_title');
    var symbol1 = property(first, '_bracelet_symbol_1_title');
    var symbol2 = property(first, '_bracelet_symbol_2_title');
    var image = cfg.images && (cfg.images[presetKey] || cfg.images.focus);
    var total = lines.reduce(function (sum, line) {
      return sum + (Number(line.final_line_price) || 0);
    }, 0);
    var originalTotal = lines.reduce(function (sum, line) {
      return sum + (Number(line.original_line_price) || 0);
    }, 0);

    if (!image) image = first.image || (first.featured_image && first.featured_image.url) || '';
    if (!bar) {
      var barLine = starter.find(function (line) { return property(line, '_bracelet_slot') === 'starter_bar'; });
      bar = barLine && barLine.product_title;
    }
    if (!symbol1 || !symbol2) {
      var symbolLines = starter.filter(function (line) {
        return property(line, '_bracelet_slot') === 'starter_symbol_1' || property(line, '_bracelet_slot') === 'starter_symbol_2';
      });
      symbol1 = symbol1 || (symbolLines[0] && symbolLines[0].product_title);
      symbol2 = symbol2 || (symbolLines[1] && symbolLines[1].product_title);
    }

    return {
      id: property(first, '_bracelet_build_id'),
      name: displayName,
      bar: bar || '',
      symbols: [symbol1, symbol2].filter(Boolean).join(' + '),
      image: image,
      total: total,
      savings: Math.max(0, originalTotal - total),
      incomplete: starter.length !== STARTER_SLOTS.length
    };
  }

  function builderUrl(buildId) {
    var cfg = config();
    var url = new URL('/products/test-bracelet-base', window.location.origin);
    url.searchParams.set('view', 'bracelet-builder-poc');
    url.searchParams.set('edit_build', buildId);
    if (cfg.themeId) url.searchParams.set('preview_theme_id', cfg.themeId);
    return url.pathname + url.search;
  }

  function groupCard(info, currency) {
    var title = escapeHtml(info.name);
    var image = info.image ? '<img src="' + escapeHtml(info.image) + '" alt="' + title + '" loading="lazy">' : '';
    var details = [info.bar, info.symbols].filter(Boolean).map(function (detail) {
      return '<span>' + escapeHtml(detail) + '</span>';
    }).join('');
    var warning = info.incomplete ? '<p class="wr-cart-group__offer">Incomplete bracelet</p>' : '<p class="wr-cart-group__offer">Second charm &middot; 25% off</p>';
    return '<article class="wr-cart-group" data-build-id="' + escapeHtml(info.id) + '">' +
      '<div class="wr-cart-group__top"><div class="wr-cart-group__image">' + image + '</div>' +
      '<div class="wr-cart-group__body">' + warning + '<h3 class="wr-cart-group__title">' + title + '</h3>' +
      '<p class="wr-cart-group__details">' + details + '</p></div></div>' +
      '<div class="wr-cart-group__total"><span>Bracelet total</span><span class="wr-cart-group__price">' + escapeHtml(money(info.total, currency)) + '</span></div>' +
      '<div class="wr-cart-group__actions"><a class="wr-cart-group__edit" href="' + escapeHtml(builderUrl(info.id)) + '">Edit Bracelet</a>' +
      '<button class="wr-cart-group__remove" type="button" data-wr-remove-build="' + escapeHtml(info.id) + '" aria-label="Remove bracelet">' +
      '<span class="wr-cart-group__remove-label">Remove bracelet</span>' +
      '<svg class="wr-cart-group__remove-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' +
      '</article>';
  }

  function drawerGroupCard(info, currency) {
    var title = escapeHtml(info.name);
    var image = info.image ? '<img src="' + escapeHtml(info.image) + '" alt="' + title + '" loading="lazy">' : '';
    var details = [info.bar, info.symbols].filter(Boolean).map(escapeHtml).join(' &middot; ');
    return '<article class="wr-cart-drawer-group" data-build-id="' + escapeHtml(info.id) + '">' +
      '<div class="wr-cart-drawer-group__image">' + image + '</div>' +
      '<div class="wr-cart-drawer-group__body"><span class="wr-cart-drawer-group__offer">Second charm &middot; 25% off</span>' +
      '<h3 class="wr-cart-drawer-group__title">' + title + '</h3><p class="wr-cart-drawer-group__details">' + details + '</p>' +
      '<div class="wr-cart-drawer-group__actions"><a href="' + escapeHtml(builderUrl(info.id)) + '">Edit Bracelet</a>' +
      '<button type="button" data-wr-remove-build="' + escapeHtml(info.id) + '">Remove bracelet</button></div></div>' +
      '<span class="wr-cart-drawer-group__price">' + escapeHtml(money(info.total, currency)) + '</span></article>';
  }

  function hideNativeBuildLines(cart) {
    (cart.items || []).forEach(function (line, index) {
      if (!property(line, '_bracelet_build_id')) return;
      ['CartItem-' + (index + 1), 'CartDrawer-Item-' + (index + 1)].forEach(function (id) {
        var row = document.getElementById(id);
        if (!row) return;
        row.hidden = true;
        row.style.setProperty('display', 'none', 'important');
        row.setAttribute('aria-hidden', 'true');
        row.querySelectorAll('button,input,a[href*="/cart/change"]').forEach(function (control) {
          control.setAttribute('tabindex', '-1');
          if ('disabled' in control) control.disabled = true;
        });
      });
    });
  }

  function standaloneImage(item) {
    var cfg = config();
    var images = cfg.images || {};
    var title = String(item.product_title || '').toLowerCase();
    var fallback = images.focus;

    if (/trust|hive|dollar|growth/.test(title)) fallback = images.growth || fallback;
    if (/know your why|ripple|purpose/.test(title)) fallback = images.purpose || fallback;

    return item.image || (item.featured_image && item.featured_image.url) || fallback || '';
  }

  function fillMissingStandaloneImages(cart) {
    (cart.items || []).forEach(function (item, index) {
      if (property(item, '_bracelet_build_id')) return;
      var imageUrl = standaloneImage(item);
      if (!imageUrl) return;

      ['CartItem-' + (index + 1), 'CartDrawer-Item-' + (index + 1)].forEach(function (id) {
        var row = document.getElementById(id);
        var media = row && row.querySelector('.cart-item__media');
        if (!media || media.querySelector('img')) return;

        var link = document.createElement('a');
        var image = document.createElement('img');
        link.href = item.url || '#';
        link.className = 'cart-item__link';
        image.src = imageUrl;
        image.alt = item.product_title || '';
        image.loading = 'lazy';
        image.className = 'cart-item__image';
        link.appendChild(image);
        media.appendChild(link);
      });
    });
  }

  function renderPage(cart, grouped) {
    if (window.location.pathname !== '/cart') return;
    var heading = document.querySelector('.wr-cart-page__heading');
    if (heading && !heading.querySelector('em')) heading.innerHTML = 'Your bracelet, <em>your way</em>.';
    var mount = document.getElementById('wr-poc-cart-groups-mount');
    if (!mount) return;
    var shell = document.getElementById('wr-cart-groups');
    if (!shell) {
      shell = document.createElement('section');
      shell.id = 'wr-cart-groups';
      shell.setAttribute('aria-label', 'Bracelets in your cart');
      mount.prepend(shell);
    }
    shell.innerHTML = grouped.order.map(function (id) {
      return groupCard(buildInfo(grouped.groups[id]), cart.currency);
    }).join('');
  }

  function renderSummary(cart, grouped) {
    var mount = document.querySelector('[data-wr-order-summary-lines]');
    if (!mount) return;
    var lines = [];
    grouped.order.forEach(function (id) {
      var info = buildInfo(grouped.groups[id]);
      lines.push('<div class="wr-cart-summary__line"><span>' + escapeHtml(info.name) + '</span><span>' + escapeHtml(money(info.total, cart.currency)) + '</span></div>');
    });
    grouped.standalone.forEach(function (item) {
      lines.push('<div class="wr-cart-summary__line"><span>' + escapeHtml(item.product_title) + '</span><span>' + escapeHtml(money(item.final_line_price, cart.currency)) + '</span></div>');
    });
    lines.push('<div class="wr-cart-summary__line"><span>Subtotal</span><span>' + escapeHtml(money(cart.items_subtotal_price || cart.total_price, cart.currency)) + '</span></div>');
    mount.innerHTML = lines.join('');

    var savings = Math.max(0, Number(cart.original_total_price || 0) - Number(cart.total_price || 0));
    var savingsMount = document.querySelector('[data-wr-cart-savings]');
    if (savingsMount) {
      savingsMount.hidden = savings <= 0;
      savingsMount.innerHTML = savings > 0 ? '<strong>You saved ' + escapeHtml(money(savings, cart.currency)) + '</strong><small>25% off your second Charm is already reflected.</small>' : '';
    }

    var totalLabel = document.querySelector('.wr-cart-footer .totals__total');
    if (totalLabel) totalLabel.textContent = 'Total';
    var checkout = document.querySelector('.wr-cart-footer .cart__checkout-button');
    if (checkout) checkout.textContent = 'Checkout';
    var taxNote = document.querySelector('.wr-cart-footer .tax-note');
    if (taxNote) taxNote.textContent = 'Secure Shopify checkout · Taxes and shipping calculated next.';
  }

  function renderDrawer(cart, grouped) {
    var drawerItems = document.querySelector('cart-drawer-items');
    if (!drawerItems) return;
    var mount = document.getElementById('wr-cart-drawer-groups');
    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'wr-cart-drawer-groups';
      drawerItems.prepend(mount);
    }
    mount.innerHTML = grouped.order.map(function (id) {
      return drawerGroupCard(buildInfo(grouped.groups[id]), cart.currency);
    }).join('');

    var header = document.querySelector('.drawer__heading');
    if (header) header.textContent = 'Your bag';
    var count = document.querySelector('.wr-cart-drawer__count');
    if (!count && header && header.parentNode) {
      count = document.createElement('p');
      count.className = 'wr-cart-drawer__count';
      header.parentNode.insertAdjacentElement('afterend', count);
    }
    if (count) count.textContent = String(grouped.order.length + grouped.standalone.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0)) + ' items';

    var footer = document.querySelector('.drawer__footer');
    var savings = Math.max(0, Number(cart.original_total_price || 0) - Number(cart.total_price || 0));
    var savingsRow = document.querySelector('.wr-cart-drawer__savings');
    if (!savingsRow && footer) {
      savingsRow = document.createElement('div');
      savingsRow.className = 'wr-cart-drawer__savings';
      var totals = footer.querySelector('.totals');
      if (totals) totals.insertAdjacentElement('beforebegin', savingsRow);
    }
    if (savingsRow) {
      savingsRow.hidden = savings <= 0;
      savingsRow.innerHTML = savings > 0 ? '<span>Second Charm &mdash; 25% off</span><strong>&minus;' + escapeHtml(money(savings, cart.currency)) + '</strong>' : '';
    }

    var drawerTotalLabel = document.querySelector('.drawer__footer .totals__total');
    if (drawerTotalLabel) drawerTotalLabel.textContent = 'Subtotal';
    var drawerTaxNote = document.querySelector('.drawer__footer .tax-note');
    if (drawerTaxNote) drawerTaxNote.textContent = 'Shipping and taxes calculated at checkout.';
    var drawerCheckout = document.querySelector('.drawer__footer .cart__checkout-button');
    if (drawerCheckout) drawerCheckout.textContent = 'Checkout';

    var ctas = document.querySelector('.drawer__footer .cart__ctas');
    if (ctas && !document.querySelector('.wr-cart-drawer__view-bag')) {
      ctas.insertAdjacentHTML('beforeend', '<a class="wr-cart-drawer__view-bag" href="/cart">View Bag</a>');
    }
    if (footer && !footer.querySelector('.wr-cart-drawer__reassurance')) {
      footer.insertAdjacentHTML('beforeend', '<div class="wr-cart-drawer__reassurance"><strong>Free U.S. shipping on orders over $210</strong>Your complete bracelet stays grouped all the way to checkout.</div>');
    }
  }

  function render(cart) {
    var grouped = groupedCart(cart);
    hideNativeBuildLines(cart);
    fillMissingStandaloneImages(cart);
    renderPage(cart, grouped);
    renderSummary(cart, grouped);
    renderDrawer(cart, grouped);
  }

  function signature(cart) {
    return (cart.items || []).map(function (item) {
      return [item.key, item.quantity, item.final_line_price].join(':');
    }).join('|') + ':' + cart.total_price;
  }

  function refresh(force) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      fetchCart().then(function (cart) {
        var nextSignature = signature(cart);
        if (!force && nextSignature === lastSignature) {
          hideNativeBuildLines(cart);
          return;
        }
        lastSignature = nextSignature;
        render(cart);
      }).catch(function (error) {
        console.error('W&R cart presentation failed', error);
      });
    }, force ? 0 : 80);
  }

  function removeBuild(buildId, button) {
    if (!window.confirm('Remove this complete bracelet and all of its grouped components from your bag?')) return;
    button.disabled = true;
    button.textContent = 'Removing bracelet...';
    fetchCart().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        if (property(item, '_bracelet_build_id') === buildId) updates[item.key] = 0;
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('The bracelet could not be removed safely.');
      window.location.reload();
    }).catch(function (error) {
      button.disabled = false;
      button.textContent = 'Remove bracelet';
      window.alert(error.message);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wr-remove-build]');
    if (!button) return;
    removeBuild(button.getAttribute('data-wr-remove-build'), button);
  });

  function boot() {
    refresh(true);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { refresh(false); }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
